module.exports = __webpack_public_path__ + "static/sb_presets-f26e0730c7783e41c6bc3ab2584f902d.mp4";